import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {getRole} from '../../../../../../utility/jwtUtil';
import {ROLES} from '../../../../../../constants/roles';
import DOMPurify from 'dompurify';
import {useSelector} from 'react-redux';

const replaceIfNotNull = (originalText, placeholder, value) => {
    if (value !== null && value !== undefined) {
        const regex = new RegExp(placeholder, 'g');
        return originalText.replace(regex, value);
    }
    return originalText;
}

const RichEditorResultText = ({description, readonly, placeholderValues, enableValidation}) => {
    const {account} = useSelector(state => state.application);
    const [text, setText] = useState('');

    useEffect(() => {
        let resultText = description;
        if ((getRole() !== ROLES.SCHOOL_ADMIN && getRole() !== ROLES.MEMBER_OF_STAFF) || readonly) {
            resultText = description;
            resultText = replaceIfNotNull(resultText, '@Parent', placeholderValues?.parent);
            resultText = replaceIfNotNull(resultText, '@SchoolName', placeholderValues?.schoolName);
            resultText = replaceIfNotNull(resultText, '@StudentForename', placeholderValues?.studentForename);
            resultText = replaceIfNotNull(resultText, '@StudentFullName', placeholderValues?.studentFullName);
            resultText = replaceIfNotNull(resultText, '@HisHer', placeholderValues?.hisHer);
            resultText = replaceIfNotNull(resultText, '@HeShe', placeholderValues?.heShe);
            resultText = replaceIfNotNull(resultText, '@HimHer', placeholderValues?.himHer);
        }

        if (enableValidation) {
            resultText = resultText.trim();
            try {
                const parser = new DOMParser();
                const doc = parser.parseFromString(resultText, 'text/html');
                const lastElement = doc.body.lastElementChild || doc.body;
                if (lastElement.innerHTML) {
                    lastElement.innerHTML += '*';
                    resultText = doc.body.innerHTML;
                } else {
                    resultText += ' *';
                }
            } catch (error) {
                resultText += ' *'; // Fallback: append asterisk to plain text as a simple backup
            }
        }

        setText(DOMPurify.sanitize(resultText));
    }, [account, placeholderValues]);
    return (
        <div dangerouslySetInnerHTML={{__html: text}}/>
    );
};

RichEditorResultText.propTypes = {
    description: PropTypes.string.isRequired,
    readonly: PropTypes.bool.isRequired,
    placeholderValues: PropTypes.object.isRequired,
    enableValidation: PropTypes.bool.isRequired,
};

export default RichEditorResultText;